export var state = {
    isInitializing: false,
    initializationData: null,
    isLoadingMachineInformation: false,
    validationCollector: null,
    isCreating: false,
    isAdding: false,
    newAttachmentId: null,
    registration: null,
    errors: null,
};
